import {makePublicUrl} from "../url/url";
const packageJson = require("../../../main/package.json");

export const translateObjKey = (obj, t, keyOrKeys = "label", translateOptions) => {
  if (typeof obj !== "object" || Array.isArray(obj)) {
    return obj;
  }

  const optionNew = {...obj};

  if (Array.isArray(keyOrKeys)) {
    for (const key of keyOrKeys) {
      optionNew[key] = t(optionNew[key], translateOptions);
    }
  } else {
    optionNew[keyOrKeys] = t(optionNew[keyOrKeys], translateOptions);
  }

  return optionNew;
};

export const translateObjectsArray = (options, t, config) => {
  let keyOrKeys, translateOptions;

  if (config) {
    keyOrKeys = config.keyOrKeys;
    translateOptions = config.translateOptions;
  }

  if (Array.isArray(options)) {
    return options.map((o) => translateObjKey(o, t, keyOrKeys, translateOptions));
  }

  return options;
};

export const tWithPrefixHandler = (t, key, options, translateIfNoSpecialSymbol = true) => {
  if (key && key.indexOf("@") === 0) {
    return t(key.slice(1), options);
  }

  return translateIfNoSpecialSymbol ? t(key, options) : key;
};

export const i18nLoadPath = (lng, ns) => {
  return makePublicUrl("/locales/" + lng + "/" + ns + ".json") + "?v=" + packageJson.version;
};
